import { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import AddProductCompatibilityModal from "pages/ProductCompatibilities/components/AddProductCompatibilityModal";
import useAddProductCompatibilityModal from "pages/ProductCompatibilities/components/AddProductCompatibilityModal/hooks/useAddProductCompatibilityModal";

const editCellRenderer = (params) => {
  return (
    <Link to={`/admin/product-compatibilities/${params.data._id}`}>Edit</Link>
  );
};

const columns = [
  {
    field: "id",
    headerName: "bcID",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "sku",
    headerName: "SKU",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "name",
    headerName: "Name",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "edit",
    headerName: "Edit",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: editCellRenderer,
  },
];

const ProductCompatibilities = () => {
  const [baseProducts, setBaseProducts] = useState([]);
  const { showAddProductCompatibilityModal } =
    useAddProductCompatibilityModal();

  const getBaseProducts = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products`
      );
      if (response.status === 200) {
        const baseProducts = response.data.baseProducts;
        setBaseProducts(baseProducts);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getBaseProducts(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <div style={{ padding: "40px" }}>
      <Row>
        <Col xs={{ span: 6 }}>
          <h1 style={{ marginBottom: "30px" }}>Product Compatibilities</h1>
        </Col>
        <Col xs={{ span: 2, offset: 4 }}>
          <Button
            onClick={() => {
              showAddProductCompatibilityModal();
            }}
          >
            Add Compatibility
          </Button>
        </Col>
      </Row>
      <AddProductCompatibilityModal
        onAddedProductCompatibility={getBaseProducts}
        baseProducts={baseProducts}
      />
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            minWidth: 170,
          }}
          floatingFilter={true}
          columnDefs={columns}
          rowData={baseProducts}
          onGridReady={onGridReady}
          rowHeight={42}
        />
      </div>
    </div>
  );
};

export default ProductCompatibilities;
